<template>
  <div>
    <p class="establish">{{ $t("creation.establish") }}</p>
    <div class="container">
      <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="126px" class="formWrapper">
        <!-- 申请人信息填写 -->
        <personal-info ref="personalInfoRef"></personal-info>

        <!-- 申请人角色 -->
        <div class="pt50 messageWrap">
          <p class="messageTitle">{{ $t("creation.applicantRole") }}</p>
          <div class="pt36">
            <el-form-item :label="$t('creation.role')" prop="applicantPosition" ref="applicantPosition">
              <el-select v-model="dataForm.applicantPosition" :placeholder="$t('common.placeholder.select')" class="wd500">
                <el-option v-for="item in globalFormatList('applicantRoleTypeList')" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- 拟设公司/基金所在地 -->
        <div class="pt50 messageWrap">
          <p class="messageTitle">{{ $t("creation.locationTitle") }}</p>
          <div class="pt36">
            <el-form-item :label="$t('creation.country')" prop="country" ref="country">
              <el-select v-model="dataForm.country" :placeholder="$t('common.placeholder.select')" @change="countryChange" class="wd500">
                <el-option v-for="item in globalFormatList('supportServiceCountryList')" :key="item.id" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- 选择套餐 -->
        <div class="pt50 messageWrap">
          <p class="messageTitle">
            {{ $t("creation.comboTitle") }}
            <info-popover
              placement="right"
              :links="[
                {
                  zh: 'http://www.estarbizadvisor.com/index.php?m=home&c=View&a=index&aid=102',
                  en: 'http://en.estarbizadvisor.com/index.php?m=home&c=View&a=index&aid=103',
                  label: $t('creation.query01'),
                },
                {
                  zh: 'http://www.estarbizadvisor.com/index.php?m=home&c=View&a=index&aid=105',
                  en: 'http://en.estarbizadvisor.com/index.php?m=home&c=View&a=index&aid=105',
                  label: $t('creation.query02'),
                },
                {
                  zh: 'http://www.estarbizadvisor.com/index.php?m=home&c=View&a=index&aid=111',
                  en: 'http://en.estarbizadvisor.com/index.php?m=home&c=View&a=index&aid=110',
                  label: $t('creation.query03'),
                },
              ]"
            />
          </p>
          <div class="pt36">
            <!-- 主体类型 -->
            <el-form-item :label="$t('creation.entityType')" prop="businessGenre" ref="businessGenre">
              <el-select v-model="dataForm.businessGenre" :placeholder="$t('common.placeholder.select')" class="wd500" @change="businessGenreChange">
                <el-option v-for="item in businessGenreOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <!-- 业务类型 -->
            <el-form-item :label="$t('creation.businessType')" prop="businessType" ref="businessType">
              <el-select v-model="dataForm.businessType" :placeholder="$t('common.placeholder.select')" class="wd500" @change="businessTypeChange">
                <el-option v-for="item of businessTypeOptions" :key="item.id" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <!-- [公司设立] / [公司服务的转移 – 公司秘书相关的服务] -->
            <div v-if="dataForm.businessType == 'COMPANY_INCORPORATION' || dataForm.businessType == 'SERVICE_TRANSFER'">
              <package-list ref="packageListRef" :country="dataForm.country" :businessType="dataForm.businessType" />
            </div>

            <!-- [综合性公司服务 – 定制化] / [基金托管服务 – 定制化] -->
            <div v-if="dataForm.businessType == 'COMPREHENSIVE_CUSTOMIZED' || dataForm.businessType == 'FUND_ADMIN_CUSTOMIZED'">
              <customized-service ref="customizedServiceRef" :businessGenre="dataForm.businessGenre" />
            </div>
          </div>
        </div>

        <!-- 底部说明banner -->
        <bottom-banner :country="dataForm.country" :businessType="dataForm.businessType" />

        <!-- 保存 -->
        <el-form-item class="pt70">
          <el-button type="primary" :loading="submitLoading" class="pl40 pr40 fz16 ml10" @click="dataFormSubmit">{{ $t("creation.createApplication") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/api/common";
import { validateLocation } from "@/utils/common";
import PersonalInfo from "./components/PersonalInfo";
import PackageList from "./components/PackageList";
import CustomizedService from "./components/CustomizedService";
import BottomBanner from "./components/BottomBanner";
import pageGuardMixin from "@/mixins/pageGuardMixin";
import { mapState, mapGetters } from "vuex";
export default {
  name: "EnrollCreation",
  mixins: [pageGuardMixin],
  components: {
    PackageList,
    CustomizedService,
    PersonalInfo,
    BottomBanner,
  },
  data() {
    return {
      dataForm: {
        applicantPosition: "",
        country: "",
        businessGenre: "",
        businessType: "",
      },
      dataRule: {
        applicantPosition: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        country: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        businessGenre: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        businessType: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
      },
      businessGenreOptions: [], // 主体类型选项
      businessTypeOptions: [], // 业务类型选项
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("user", ["isCoordinator"]),
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList", "getApplyStepList"]),
  },
  methods: {
    // 国家 - change
    countryChange() {
      // 初始化【主体类型】选中项
      this.initFormSelected("businessGenre");
      // 主体类型 - change
      this.businessGenreChange();
    },
    // 主体类型 - change
    businessGenreChange() {
      // 初始化【业务类型】选中项
      this.initFormSelected("businessType");
    },
    // 业务类型 - change
    businessTypeChange() {
      this.$nextTick(() => {
        // 初始化套餐列表
        this.$refs.packageListRef?.init();
        // 初始化自定义服务
        this.$refs.customizedServiceRef?.init();
      });
    },
    // 保存 - 按钮
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async (valid, object) => {
        if (valid) {
          this.saveRequestState = 1;
          let params = {
            ...this.dataForm,
          };
          const personalInfoResult = await this.$refs.personalInfoRef.dataFormSubmit();
          params = { ...params, ...personalInfoResult };
          if (this.$refs.packageListRef) {
            const packageListResult = await this.$refs.packageListRef.dataFormSubmit();
            params = { ...params, ...packageListResult };
          }
          if (this.$refs.customizedServiceRef) {
            const customizedServiceResult = await this.$refs.customizedServiceRef.dataFormSubmit();
            params = { ...params, ...customizedServiceResult };
          }
          this.$confirm(this.$t("common.hint.createForm"), this.$t("common.hint.title"), {
            type: "warning",
          }).then(() => {
            this.submitLoading = true;
            postRequest("/companyApplyment/create", params)
              .then(res => {
                this.saveRequestState = 2;
                // 保存成功
                this.$message({
                  message: this.$t("common.success.save"),
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    const { country, businessType, isLaterService } = params;
                    const currentSteps = this.getApplyStepList(country, businessType, isLaterService);
                    const path = currentSteps[0]?.currentPath;
                    this.$router.replace({
                      path,
                      query: {
                        id: res.data,
                      },
                    });
                  },
                });
              })
              .catch(() => {
                this.saveRequestState = 3;
                this.submitLoading = false;
              });
          });
        } else {
          validateLocation(object, this);
          return false;
        }
      });
    },
    // 初始化表单select默认选中值
    initFormSelected(type) {
      // 角色
      if (type == "applicantPosition") {
        const applicantRoleTypeList = this.globalFormatList("applicantRoleTypeList") || [];
        this.$set(this.dataForm, "applicantPosition", applicantRoleTypeList[0]?.value || "");
      }
      // 国家
      if (type == "country") {
        const supportServiceCountryList = this.globalFormatList("supportServiceCountryList") || [];
        this.$set(this.dataForm, "country", supportServiceCountryList[0]?.value || []);
      }
      // 主体类型
      if (type == "businessGenre") {
        const businessGenreList = this.byCountryFormatList("businessGenreData", this.dataForm.country) || [];
        this.businessGenreOptions = businessGenreList;
        this.$set(this.dataForm, "businessGenre", businessGenreList[0]?.value || "");
      }
      // 业务类型
      if (type == "businessType") {
        const businessGenreList = this.byCountryFormatList("businessGenreData", this.dataForm.country) || [];
        const businessTypeList = businessGenreList.find(item => item.value == this.dataForm.businessGenre)?.children || [];
        this.businessTypeOptions = businessTypeList;
        this.$set(this.dataForm, "businessType", businessTypeList[0]?.value || "");
        this.$nextTick(() => {
          // 初始化套餐列表
          this.$refs.packageListRef?.init();
          // 初始化自定义服务
          this.$refs.customizedServiceRef?.init();
        });
      }
    },
  },
  created() {
    const query = this.$route.query;
    if (query.id) {
      // 给出提示：该订单已经创建，禁止修改
      this.$message({
        message: this.$t("common.error.notAllow"),
        type: "error",
        duration: 1000,
        onClose: () => {
          this.saveRequestState = 2;
          this.$router.replace("/");
        },
      });
    } else {
      // 初始化select默认选中值
      const initTypeList = ["applicantPosition", "country", "businessGenre", "businessType"];
      initTypeList.forEach(item => {
        this.initFormSelected(item);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.establish {
  font-size: 28px;
  color: #011a45;
  padding: 30px 0;
  max-width: 1400px;
  margin: 0 auto;
}

.messageTitle {
  /* border-left: 2px solid #409eff; */
  border-radius: 2px;
  font-size: 16px;
  /* padding-left: 6px; */
  line-height: 1em;
  font-weight: 600;
}

.formWrapper {
  ::v-deep {
    .el-form-item__label {
      height: 38px;
      line-height: 16px;
      display: flex;
      align-items: center;
      text-align: left;
      /* word-break: break-all; */
    }

    .el-input-group__prepend {
      height: 36px;
      line-height: 36px;
    }
  }
}
</style>
